import { create } from 'zustand';

interface IntegrationsStore {
  activeEntityId: string | null;
  setActiveEntityId: (entityId: string | null) => void;
}

export const useIntegrationsStore = create<IntegrationsStore>((set) => ({
  activeEntityId: null,
  setActiveEntityId: (entityId) => set({ activeEntityId: entityId }),
}));
